// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleRecommendation_container__ugFuH","title":"ArticleRecommendation_title__ehCFv","articles":"ArticleRecommendation_articles__zOOcx"};